function Hero() {
    return (
        <section className="hero">
            <div className="hero-bg" aria-hidden="true"></div>
                <div className="container hero-grid">
                    <div className="hero-copy reveal">
                    <div className="badge">
                        <span className="badge-pill">CONTS CONTABILIDADE</span>
                        <span className="badge-text">Contabilidade • Fiscal • Tributário • Consultoria</span>
                    </div>

                    <h1 className="hero-title">
                        Cresça com segurança, eficiência e <span className="gradient-text">inteligência tributária</span>.
                    </h1>

                    <p className="hero-subtitle">
                        Soluções personalizadas para pessoas físicas, prestadores de serviço, comércio e indústria.
                        Uma contabilidade que entende o seu negócio e ajuda você a decidir melhor.
                    </p>

                    <div className="hero-actions">
                        <a className="btn btn-primary" href="https://wa.me/5519995277000" target="_blank">Entrar em contato</a>
                        <a className="btn btn-ghost" href="#about">Conheça nossa história</a>
                    </div>

                    <div className="hero-stats">
                        <div className="stat-card reveal">
                        <div className="stat-number" data-count="518">0</div>
                        <div className="stat-label">clientes satisfeitos</div>
                        </div>
                        <div className="stat-card reveal">
                        <div className="stat-number" data-count="100">0</div>
                        <div className="stat-label">foco em conformidade</div>
                        </div>
                        <div className="stat-card reveal">
                        <div className="stat-number" data-count="5">0</div>
                        <div className="stat-label">áreas de atuação</div>
                        </div>
                    </div>
                    </div>

                    <div className="hero-visual reveal">
                    <div className="mockup-card">
                        <div className="mockup-header">
                        <span className="chip">ESPECIALIDADES</span>
                        <span className="mockup-title">Entenda como podemos ajudar você</span>
                        </div>

                        <div className="mockup-list">
                        <div className="mockup-item">
                            <div className="mockup-ico" aria-hidden="true">📌</div>
                            <div>
                            <strong>Planejamento Tributário</strong>
                            <p>Estratégias para otimizar a carga tributária com segurança.</p>
                            </div>
                        </div>
                        <div className="mockup-item">
                            <div className="mockup-ico" aria-hidden="true">✅</div>
                            <div>
                            <strong>Rotinas Fiscais</strong>
                            <p>Obrigações em dia e acompanhamento de mudanças legais.</p>
                            </div>
                        </div>
                        <div className="mockup-item">
                            <div className="mockup-ico" aria-hidden="true">👥</div>
                            <div>
                            <strong>Departamento Pessoal</strong>
                            <p>Suporte trabalhista e previdenciário para sua equipe.</p>
                            </div>
                        </div>
                        </div>

                        <a className="btn btn-primary btn-full" href="#services">Saiba mais</a>
                    </div>

                    <div className="floating-card">
                        <div className="floating-icon" aria-hidden="true">📊</div>
                        <div>
                        <strong>Indicadores claros</strong>
                        <p>Acompanhe resultados e tome decisões com confiança.</p>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="scroll-hint" aria-hidden="true">
                    <span className="mouse"></span>
                    <span className="scroll-text">Role para ver mais</span>
                </div>
        </section>
    ); 
}

export default Hero;